import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { PenLine, ShieldCheck, Timer } from 'lucide-react'
import Confetti, { SOFT_CONFETTI } from '@/components/landing/confetti'
import RsvpForm from '@/components/landing/rsvp-form'
import SectionHeading from '@/components/landing/section-heading'
import { invitation } from '@/constants/invitation'

const RsvpSection: FC = (): ReactNode => {
    const { rsvpDeadline } = invitation

    const reassurances = [
        { icon: Timer, text: "Moins d’une minute pour répondre" },
        { icon: PenLine, text: "Modifiable à tout moment avec la même adresse e-mail" },
        { icon: ShieldCheck, text: "Vos informations restent entre nous, promis" }
    ]

    return (
        <section id='rsvp' aria-labelledby='rsvp-titre' className='relative isolate overflow-hidden bg-secondary py-24 sm:py-32'>
            <Confetti pieces={SOFT_CONFETTI} className='-z-10' />

            <div className='mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16'>
                <div className='lg:pt-4'>
                    <SectionHeading
                        id='rsvp-titre'
                        eyebrow="Réponse attendue"
                        title="Serez-vous des nôtres ?"
                        description={`Merci de répondre avant le ${rsvpDeadline}, même si vous ne pouvez pas venir. Ça m’aide énormément pour l’organisation !`}
                    />

                    <ul className='mt-10 space-y-4'>
                        {reassurances.map(({ icon: Icon, text }) => (
                            <li key={text} className='flex items-center gap-3 font-medium'>
                                <span className='grid size-10 shrink-0 place-items-center rounded-full bg-card text-primary shadow-sm'>
                                    <Icon className='size-5' aria-hidden='true' />
                                </span>
                                {text}
                            </li>
                        ))}
                    </ul>

                    <div className='relative mt-12 hidden aspect-[16/10] overflow-hidden rounded-[2rem] shadow-xl shadow-foreground/10 lg:block'>
                        <Image
                            src='/images/partage.jpg'
                            alt=''
                            fill
                            sizes='30rem'
                            className='object-cover'
                        />
                    </div>
                </div>

                <div className='rounded-[2rem] bg-card p-6 shadow-2xl shadow-primary/10 ring-1 ring-foreground/5 sm:p-10'>
                    <RsvpForm />
                </div>
            </div>
        </section>
    )
}

export default RsvpSection
